import { render, staticRenderFns } from "./detailsFacture.vue?vue&type=template&id=4181d24a&"
import script from "./detailsFacture.vue?vue&type=script&lang=js&"
export * from "./detailsFacture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports